const LETTER_FIRST = /^\p{L}/u;

export const startsWithLetter = (value: string): boolean =>
  LETTER_FIRST.test(value);
